angular
	.module('components.planodiretor')
	.controller('PlanoDiretorController', PlanoDiretorController);

function PlanoDiretorController(
	$stateParams, URL_LOGOS, $scope, $timeout, $http, PlanoDiretorService, URL_GEOSERVER,
	ngDialog, PlanoDiretorRelatorioService, $window, $state, toastr, URL_REST
) {
	var vm = this;

	vm.controleMenu = {
		// Menu da tela
		mostrarMenuOrto: false,
		mostrarMenuCamada: false,
		mostrarMenuPesquisa: false,
		mostrarMenuSistema: false,
		mostrarMenuMedicao: false,
		mostrarMenuInfo: false,
		// Modais de informações
		mostrarMenuVetor: false,
		mostrarMenuFiltro: false
	};

	var EPSG = 'EPSG:4326';
	// var EPSG = 'EPSG:3857';

	var view = new ol.View({
		// projection: EPSG,
		// center: [-51, -12],
		center: ol.proj.transform([-51, -12], EPSG, 'EPSG:3857'),
		zoom: 4
	});

	vm.map = new ol.Map({
		layers: [
			new ol.layer.Tile({
				name: 'osm',
				preload: 4,
				source: new ol.source.OSM()
			})
		],
		controls: [],
		target: 'mapa-sistema',
		view: view
	});

	vm.iniciar = function () {
		vm.carregarCliente();
	};

	vm.carregarCliente = function () {
		PlanoDiretorService.buscarCliente($stateParams.slug).then(function (result) {
			vm.cidade = result.data;
			vm.schema = vm.cidade['clien_workspace'];
			vm.brasao = URL_LOGOS + vm.cidade['clien_logo'];
			vm.excecoesClickVetor = vm.cidade['excecoes']['clickVetor'];

			// Dados geoserevr
			vm.geoserver_url = vm.cidade['url_geoserver']['serv_url'];
			vm.geoserver_servico = vm.cidade['url_geoserver']['serv_servico'];

			var coordenadas = [parseFloat(vm.cidade['clien_long']), parseFloat(vm.cidade['clien_lat'])];
			view.animate({
				projection: EPSG,
				center: ol.proj.transform(coordenadas, EPSG, 'EPSG:3857'),
				zoom:  parseInt(vm.cidade['clien_zoom']),
				duration: 1
			});

			vm.carregarGrupos();
			iniciarFiltro();
		});
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Zoom

	vm.zoomIn = function () {
		// vm.map.getView().setZoom(vm.map.getView().getZoom() + 1);
		vm.map.getView().animate({
			zoom: vm.map.getView().getZoom() + 1,
			duration: 300
		})
	};

	vm.zoomOut = function () {
		// vm.map.getView().setZoom(vm.map.getView().getZoom() - 1);
		vm.map.getView().animate({
			zoom: vm.map.getView().getZoom() - 1,
			duration: 300
		})
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Iniciar camadas

	function ajustarLayersRest (array) {
		return _.map(array, function (obj) {
			obj.is_visible = parseInt(obj.is_visible);
			obj.mosaico = parseInt(obj.mosaico);
			obj.ordem = parseInt(obj.ordem);
			return obj;
		});
	}

	vm.carregarGrupos = function () {
		vm.grupos = vm.cidade['grupos'];
		vm.carregarCamadas();
	};

	vm.carregarCamadas = function () {
		var tiles = [];

		vm.grupos.forEach(function (grupo, index) {
			var camadasDoGrupo = ajustarLayersRest(grupo.layers);
			var layers = _.sortBy(camadasDoGrupo, 'ordem');
			vm.grupos[index]['id'] = index;

			layers.forEach(function (camada) {
				if (camada['mosaico'] === 0) {
					tiles.push(
						new ol.layer.Image({
							name: camada['slug'],
							label: camada['label'],
							group: index,
							group_slug: grupo['slug'],
							visible: camada['is_visible'],
							source: new ol.source.ImageWMS({
								url: vm.geoserver_url + '/' + vm.schema + '/' + vm.geoserver_servico,
								params: {
									FORMAT: 'image/png',
									VERSION: '1.3.0',
									tiled: false,
									STYLES: '',
									LAYERS: vm.schema + ':' + camada['slug']
								},
								serverType: 'geoserver',
								crossOrigin: 'anonymous'
							})
						})
					);
				} else {
					tiles.push(
						new ol.layer.Tile({
							visible: camada['is_visible'],
							name: camada['slug'],
							label: camada['label'],
							group: index,
							group_slug: grupo['slug'],
							source: new ol.source.TileWMS({
								url: vm.geoserver_url + '/' + vm.schema + '/' + vm.geoserver_servico,
								params: {
									FORMAT: 'image/png',
									VERSION: '1.3.0',
									tiled: true,
									STYLES: '',
									LAYERS: vm.schema + ':' + camada['slug']
								},
								serverType: 'geoserver',
								crossOrigin: 'anonymous'
							})
						})
					);
				}
			});
		});

		vm.iniciarCamadaOL(tiles);
		vm.eventoClick();
	};

	vm.iniciarCamadaOL = function (tiles) {
		vm.mapeamentoCamadas = [];
		vm.mapeamentoOrtofotos = [];

		tiles.forEach(function (layer) {
			vm.map.addLayer(layer);
			var obj = {
				'name': layer.get('name'),
				'label': layer.get('label'),
				'visivel': layer.get('visible') === 1,
				'grupo': layer.get('group')
			};
			if (layer.get('group_slug') === 'base') {
				vm.mapeamentoOrtofotos.push(obj);
			} else {
				vm.mapeamentoCamadas.push(obj);
			}
		});

		// adicao OSM
		vm.mapeamentoOrtofotos.push({
			'name': 'osm',
			'label': 'OSM',
			'visivel': true,
			'grupo': -1
		});

		vm.mapeamentoOrtofotos = vm.mapeamentoOrtofotos.reverse();
		vm.mapeamentoCamadas = vm.mapeamentoCamadas.reverse();
	};

	vm.toggleCamada = function (obj) {
		setTimeout(function () {
			var layer = vm.buscarCamada(obj.name);
			layer.setVisible(obj.visivel);

			var layerMapeamento = vm.buscarCamadaMapeamento(obj.name);
			layerMapeamento.visivel = obj.visivel;

			$scope.$apply();
		}, 0);
	};

	vm.toggleGrupo = function (obj) {
		setTimeout(function () {
			var camadasFilhas = _.where(vm.mapeamentoCamadas, {'grupo': obj.id});

			camadasFilhas.forEach(function (camada) {
				camada.visivel = obj.visivel;
				vm.toggleCamada(camada);
			});
		}, 0);
	};

	vm.buscarCamadasGrupo = function (grupo) {
		return _.where(vm.mapeamentoCamadas, {'grupo': grupo.id})
	};

	vm.buscarCamada = function (nomeCamada) {
		var layer = null;
		for (var i = 0; i < vm.map.getLayers().getLength(); i++) {
			var layerCorrente = vm.map.getLayers().getArray()[i];

			if (layerCorrente.get('name') === nomeCamada) {
				layer = layerCorrente;
				break;
			}
		}
		return layer
	};

	vm.buscarCamadaMapeamento = function (nomeCamada) {
		var layer = null;
		for (var i = 0; i < vm.mapeamentoCamadas.length; i++) {
			var layerCorrente = vm.mapeamentoCamadas[i];

			if (layerCorrente.name === nomeCamada) {
				layer = layerCorrente;
				break;
			}
		}
		return layer
	};

	vm.selecionarCamada = function (obj) {
		if (vm.controleMenu.mostrarMenuInfo) {
			vm.camadaSelecionada = obj
		} else {
			vm.deselecionarCamada();
		}
	};

	// deselecionar camada seta a camada default (no caso lote)
	vm.deselecionarCamada = function () {
		// TODO preciso que venha do servico especificado qual sera o default
		vm.camadaSelecionada = {
			name: "lotes_v51",
			label: "Lotes",
			visivel: true,
			grupo: "166"
		};
	};

	vm.acionarMenuInformacao = function () {
		vm.controleMenu.mostrarMenuInfo = !vm.controleMenu.mostrarMenuInfo
		if (!vm.controleMenu.mostrarMenuInfo) {
			vm.deselecionarCamada();
		}
	};

	vm.deselecionarCamada();  // inicializa a variavel

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Medicao

	<!-- Popover faz uso da tecnologia templateCache, aqui eh colocado a chave do template -->
	<!-- Vide arquivo dist/js/bundle.js, no final -->

	vm.templatePopover = './medicao-area.html';
	vm.feicoes = [];

	vm.draw = null;
	vm.medicaoSource = null;
	vm.medicaoLayer = null;

	vm.medirLinha = function () {
		vm.cancelarMedicao();
		vm.iniciarMedicao('LineString');
	};

	vm.medirArea = function () {
		vm.cancelarMedicao();
		vm.iniciarMedicao('Polygon');
	};

	vm.medir = function () {
		if (vm.controleMenu.mostrarMenuMedicao) {
			vm.iniciarMedicao('Polygon');
		} else {
			vm.cancelarMedicao();
		}
	};

	vm.cancelarMedicao = function () {
		vm.map.removeInteraction(vm.draw);
		vm.draw = null;
		vm.map.removeLayer(vm.medicaoLayer);
		vm.medicaoSource = null;
		vm.medicaoLayer = null;
		vm.feicoes = [];
		$(".ol-overlay-container.ol-selectable").remove();
	};

	vm.iniciarMedicao = function (tipo) {
		// tipo: 'LineString' | 'Polygon'

		vm.medicaoSource = new ol.source.Vector();

		vm.medicaoLayer = new ol.layer.Vector({
			name: 'medicao',
			source: vm.medicaoSource,
			style: new ol.style.Style({
				fill: new ol.style.Fill({
					color: 'rgba(255, 255, 255, 0.2)'
				}),
				stroke: new ol.style.Stroke({
					color: '#ffcc33',
					width: 2
				}),
				image: new ol.style.Circle({
					radius: 7,
					fill: new ol.style.Fill({
						color: '#ffcc33'
					})
				})
			})
		});

		vm.map.addLayer(vm.medicaoLayer);

		var sketch;  // Feature de desenho corrent
		var helpTooltipElement;  // Elemento tooltip de ajuda
		var helpTooltip;  // Overlay para mostrar as mensagens de ajuda
		var measureTooltipElement;  // Elemento tooltip da medicao
		var measureTooltip;  // Overlay para mostrar medicao
		var continuePolygonMsg = 'Clique para continuar desenhando o polígono';  // Mensagem qnd estiver desenhando o poligono
		var continueLineMsg = 'Clique para continuar desenhando a linha';  // Mensagem qnd estiver desenhando a linha
		var listener;

		addInteraction();

		function addInteraction() {
			vm.draw = new ol.interaction.Draw({
				source: vm.medicaoSource,
				type: (tipo)
			});

			vm.map.addInteraction(vm.draw);

			createMeasureTooltip();
			createHelpTooltip();

			// Cria tooltip de help
			function createHelpTooltip() {
				if (helpTooltipElement) {
					helpTooltipElement.parentNode.removeChild(helpTooltipElement);
				}
				helpTooltipElement = document.createElement('div');
				helpTooltipElement.className = 'tooltip-mapa hidden';
				helpTooltip = new ol.Overlay({
					element: helpTooltipElement,
					offset: [15, 0],
					positioning: 'center-left'
				});
				vm.map.addOverlay(helpTooltip);
			}

			// Cria tooltipo de medicao
			function createMeasureTooltip() {
				if (measureTooltipElement) {
					measureTooltipElement.parentNode.removeChild(measureTooltipElement);
				}
				measureTooltipElement = document.createElement('div');
				measureTooltipElement.className = 'tooltip-mapa tooltip-measure-mapa';
				measureTooltip = new ol.Overlay({
					element: measureTooltipElement,
					offset: [0, -15],
					positioning: 'bottom-center'
				});
				vm.map.addOverlay(measureTooltip);
			}

			var formatLength = function (line) {
				var length = ol.Sphere.getLength(line);
				return formatLengthStr(length);
			};

			var formatLengthStr = function (length) {
				var output;
				if (length > 10) {
					output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
				} else {
					output = (Math.round(length * 100) / 100) + ' ' + 'm';
				}
				return output;
			}

			var formatArea = function (polygon) {
				var area = ol.Sphere.getArea(polygon);
				return formatAreaStr(area);
			};

			var formatAreaStr = function (area) {
				var output;
				if (area > 10000) {
					output = (Math.round(area / 1000000 * 100) / 100) + ' ' + 'km²';
				} else {
					output = (Math.round(area * 100) / 100) + ' ' + 'm²';
				}
				return output;
			};

			var pointerMoveHandler = function (evt) {
				if (evt.dragging) {
					return;
				}
				/** @type {string} */
				var helpMsg = 'Clique para iniciar medição';

				if (sketch) {
					var geom = (sketch.getGeometry());
					if (geom instanceof ol.geom.Polygon) {
						helpMsg = continuePolygonMsg;
					} else if (geom instanceof ol.geom.LineString) {
						helpMsg = continueLineMsg;
					}
				}

				helpTooltipElement.innerHTML = helpMsg;
				helpTooltip.setPosition(evt.coordinate);

				helpTooltipElement.classList.remove('hidden');
			};

			vm.map.on('pointermove', pointerMoveHandler);

			vm.map.getViewport().addEventListener('mouseout', function () {
				helpTooltipElement.classList.add('hidden');
			});

			vm.calcularFeicoes = function () {
				vm.feicoes = [];
				vm.feicoesTotal = 0;

				vm.medicaoLayer.getSource().getFeatures().forEach(function (feature, index) {
					var geometria = feature.getGeometry();
					var area = null;
					var area_formatada = null;

					if (geometria instanceof ol.geom.Polygon) {  // area
						area = ol.Sphere.getArea(geometria);
						// area = geometria.getArea();
						area_formatada = formatArea(geometria);
					} else if (geometria instanceof ol.geom.LineString) {  // linha
						area = ol.Sphere.getLength(geometria);
						// area = geometria.getLength();
						area_formatada = formatLength(geometria);
					} else {
						return;
					}

					vm.feicoes.push({
						'nome': 'Feição ' + (index + 1),
						'area': area_formatada
					});
					vm.feicoesTotal += area;
				});
				if (tipo === 'Polygon') {
					vm.feicoesTotal = formatAreaStr(vm.feicoesTotal);
				} else if (tipo === 'LineString') {
					vm.feicoesTotal = formatLengthStr(vm.feicoesTotal);
				} else {
					vm.feicoesTotal = 0;
				}
			};

			vm.draw.on('drawstart', function (evt) {
				sketch = evt.feature;

				var tooltipCoord = evt.coordinate;

				listener = sketch.getGeometry().on('change', function (evt) {
					var geom = evt.target;
					var output;
					if (geom instanceof ol.geom.Polygon) {
						output = formatArea(geom);
						tooltipCoord = geom.getInteriorPoint().getCoordinates();
					} else if (geom instanceof ol.geom.LineString) {
						output = formatLength(geom);
						tooltipCoord = geom.getLastCoordinate();
					}
					measureTooltipElement.innerHTML = output;
					measureTooltip.setPosition(tooltipCoord);
				});
			}, this);

			vm.draw.on('drawend', function () {
				measureTooltipElement.className = 'tooltip-mapa tooltip-static-mapa';
				measureTooltip.setOffset([0, -7]);
				// unset sketch
				sketch = null;
				// unset tooltip so that a new one can be created
				measureTooltipElement = null;
				createMeasureTooltip();
				ol.Observable.unByKey(listener);

				// aplica-se um timeout para forcar o scope apply no momento do evento
				setTimeout(function () {
					$scope.$apply(function () {
						vm.calcularFeicoes();
					});
				}, 100);
			}, this);

		}

	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// EventoClick (dados do vetor)
	vm.informacaoVetor = {};
	vm.coordenada = [];

	vm.eventoClick = function () {
		vm.map.on('singleclick', function (evt) {

			if (!vm.controleMenu.mostrarMenuMedicao) {
				var layer = vm.buscarCamada(vm.camadaSelecionada.name);
				vm.coordenada = evt.coordinate;

				vm.removerPinClick();
				criarPinClick(vm.coordenada);

				var url = layer.getSource().getGetFeatureInfoUrl(
					vm.coordenada, vm.map.getView().getResolution(),
					vm.map.getView().getProjection(),
					{'INFO_FORMAT': 'application/json'}
				);

				if (url) {
					$http.get(url).then(function (result) {
						if (result.data.features.length > 0) {
							var infogeoserver = result.data.features[0].properties;

							if (layer.get('name') === vm.excecoesClickVetor['clickVetor']) {
								var id_lote = infogeoserver[vm.excecoesClickVetor['campoFiltro']];

								console.log(vm.cidade['clien_id']);
								PlanoDiretorService.buscarLogradourosPorLote(vm.schema, id_lote, vm.cidade['clien_id']).then(function (result) {
									vm.controleMenu.mostrarMenuVetor = true;
									vm.informacaoVetor = (result.data.length > 0) ? result.data[0] : {};
								});
							}
						}
					});
				}
			}

		});
	};

	function criarPinClick(coordenada) {
		var iconStyle = new ol.style.Style({
			image: new ol.style.Icon(({
				anchor: [0.5, 1, 3],
				opacity: 1,
				scale: 1.1,
				src: 'img/pin.png'
			})),
			zIndex: -1000
		});
		var iconFeature = new ol.Feature({
			geometry: new ol.geom.Point(coordenada),
		});
		iconFeature.setStyle(iconStyle);

		vm.map.addLayer(
			new ol.layer.Vector({
				name: 'pin',
				source: new ol.source.Vector({
					features: [iconFeature]
				})
			})
		);
	}

	vm.removerPinClick = function() {
		vm.map.removeLayer(vm.buscarCamada('pin'));
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Filtro

	vm.modelFilter = null;

	vm.buscarFiltro = function () {
		var busca = [];
		var obj1 = {};
		var obj2 = {};
		var id_relacao = 0;

		_.mapObject(vm.filtroSelecionado, function(val, key) {
			if (key === 'id_relacao') {
				id_relacao = val;
			}
			if (key === 'tabela') {
				obj1[key] = val;
			}
			if (key === 'campo') {
				obj1[key] = val;
			}
			if (key === 'termo') {
				obj1[key] = val;
			}
			obj1['valor'] = vm.modelFilter.obj1;
		});

		busca.push(obj1);

		if(!_.isUndefined(vm.filtroSelecionado.condicao)) {
			_.mapObject(vm.filtroSelecionado.condicao, function (val, key) {
				if (key === 'tabela') {
					obj2[key] = val;
				}
				if (key === 'campo') {
					obj2[key] = val;
				}
				if (key === 'termo') {
					obj2[key] = val;
				}
				obj2['valor'] = vm.modelFilter.obj2;
			});
			busca.push(obj2);
		}
		var tabledata = {
			id_relacao: id_relacao,
			municipio: vm.cidade.clien_id,
			busca: busca,
			schema: vm.cidade.clien_workspace
		};

		vm.campoVazio = true;
		busca.forEach(function (obj, index) {
			if (!(obj.valor === '' || _.isUndefined(obj.valor))) {
				vm.campoVazio = false;
			}
		});

		if (!vm.campoVazio) {
			vm.controleMenu.mostrarMenuFiltro = true;
			PlanoDiretorService.aplicarFiltro(tabledata).then(function (result) {
				vm.resultadoFiltro = result.data;
				iniciarTabulatorFiltro(vm.resultadoFiltro);
			});
		}
	};

	function iniciarFiltro() {
		vm.opcoesFiltro = vm.cidade['busca_select']['select'];
	}

	function iniciarTabulatorFiltro(tabledata) {
		var table = new Tabulator("#resultado-filtro", {
			height:210, // set height of table (in CSS or here), this enables the Virtual DOM and improves render speed dramatically (can be any valid css height value)
			data: tabledata, //assign data to table
			layout:"fitData", //fit columns to width of table (optional)
			autoColumns: true,
			pagination: "local",
			paginationSize: 50,
			//paginationSizeSelector: [5, 10, 25, 50, 100],
			placeholder:"Nenhuma informação encontrada!",
			langs: {
				"pt-br": {
					"pagination": {
						"page_size":"",
						"page_title":"Página",
						"first": "<i class='fa fa-fast-backward'></i>",
						"first_title": "Primeira Página",
						"last": "<i class='fa fa-fast-forward'></i>",
						"last_title": "Última Página",
						"prev": "<i class='fa fa-step-backward'></i>",
						"prev_title": "Página Anterior",
						"next": "<i class='fa fa-step-forward'></i>",
						"next_title": "Próxima Página"
					},
					"ajax": {
						"loading": "Carregando", //ajax loader text
						"error": "Erro" //ajax error text
					}
				}
			},
			locale: "pt-br",
			rowDblClick:function(e, row){ //trigger an alert message when the row is clicked
				//alert('Aproximação para o local em desenvolvimento!');

				// var vetor = vm.vetorFiltroSelecionado;
				var vetor = 'lotes_v51';
				updateFilter('id_gpx_lot', row.getData()['Id Lote'], vm.cidade.clien_workspace, vetor);
			},
		});
	}
	vm.vetorFiltroSelecionado  = '';
	vm.eventoChangeSelectTipoFiltro = function (item) {
		vm.vetorFiltroSelecionado = item['tabela'];
		vm.filtroSelecionado = item;
	};

	function updateFilter(campo, valor, workspace, selecaoVetor) {
		var idgpx = '' + campo + '=\'' + valor + '\'';
		var filterType = "cql";
		var filter = idgpx;
		var filterParams = {
			'FILTER': null,
			'CQL_FILTER': null,
			'FEATUREID': null
		};
		if (filter.replace(/^\s\s*/, '').replace(/\s\s*$/, '') != "") {
			if (filterType == "cql") {
				filterParams["CQL_FILTER"] = filter;
			}
			if (filterType == "ogc") {
				filterParams["FILTER"] = filter;
			}
			if (filterType == "fid")
				filterParams["FEATUREID"] = filter;
		}
		var url = URL_GEOSERVER
			+ workspace + '/ows?service=WFS&version=1.0.0&request=GetFeature&typeName='
			+ workspace + ':' + selecaoVetor + '&outputFormat=application%2Fjson';

		Object.keys(filterParams).forEach(function (key) {
			if (filterParams[key]) {
				url += '&' + key + '=' + filterParams[key];
			}
		});

		var sourceEdif = new ol.source.Vector({
			url: url,
			projection: 'EPSG:3857',
			format: new ol.format.GeoJSON()
		});
		var vectorLayer = new ol.layer.Vector({
			name: selecaoVetor + '_edif',
			source: sourceEdif,
			style: new ol.style.Style({
				stroke: new ol.style.Stroke({
					color: 'red',
					width: 2
				})
			})
		});
		vm.map.addLayer(vectorLayer);
		sourceEdif.on('change', function (e) {
			if (sourceEdif.getState() === 'ready') {
				vm.map.getLayers().forEach(function (lyr, i) {
					if (i > 0 && lyr.get('name') === selecaoVetor + '_edif') {
						var extent = lyr.getSource().getFeatures()[0].getGeometry().getExtent();
						vm.map.getView().fit(extent, vm.map.getSize());
					}
				});
				$timeout(limparBuscaLayer, 3000);
				function limparBuscaLayer() {
					var layer = selecaoVetor + '_edif';
					vm.map.getLayers().forEach(function (lyr, i) {
						if (i > 0 && lyr.get('name') === layer) {
							vm.map.removeLayer(lyr);
						}
					});
				}
			}
		});
	}

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Abrir link PDF

	vm.abrirLinkPdfApi = function () {
		var informacoes = vm.informacaoVetor['usosolo_selecionado']['form'];
		informacoes['praticas_sustentaveis_aplicadas'] = vm.informacaoVetor['praticas_sustentaveis_escolhidas'];
		PlanoDiretorService.gerarPDF(informacoes).then(function (result) {
			var dados = result.data;
			 $window.open(dados,'_blank');

			// var newWindow = window.open();
			// newWindow.document.body.innerHTML = dados;
		});
	};
	vm.abrirLinkBrowser = function () { //button Imprimir
		var informacoes = vm.informacaoVetor['usosolo_selecionado']['form'];
		informacoes['praticas_sustentaveis_aplicadas'] = vm.informacaoVetor['praticas_sustentaveis_escolhidas'];
		PlanoDiretorService.gerarNoBrowser(informacoes).then(function (result) {
			var dados = result.data;
			 var newWindow = window.open();
			 newWindow.document.body.innerHTML = dados;
		});
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Modal detalhe do lote

	vm.abrirModalZoneamento = function () {
		ngDialog.open({
			template: 'modalZoneamento',
			className: 'ngdialog-theme-default',
			width: '60%',
			scope: $scope
		});
	};

	vm.abrirModalSistemaViario = function () {
		ngDialog.open({
			template: 'modalSistemaViario',
			className: 'ngdialog-theme-default',
			width: '60%',
			scope: $scope
		});
	};


	vm.abrirModalDadosLote = function () {
		ngDialog.open({
			template: 'modalDadosLote',
			className: 'ngdialog-theme-default',
			width: '95%',
			scope: $scope
		});
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Modal uso do solo

	function inicializarFormModalUsoSolo() {
		vm.formModalUsoSolo = {
			tipologia: [],
			atividade: [],
			area_util: [],
			sistema_viario: [],
			especifico: [],
			numero_pavimentos: []
		};
	}

	function inicializarModelFormDadosUsoSolo() {
		vm.modelFormDadosUsoSolo = {
			id_gpx_uso: null,
			id_gpx_tip: null,
			id_gpx_ati: null,
			id_gpx_au: null,
			id_gpx_cv: null,
			id_gpx_esp: null,
			id_gpx_afas: null,  // numero de pavimentos
		};
	}

	vm.onChangeFormModalUsoSoloTipologia = function () {
		vm.modelFormDadosUsoSolo.id_gpx_ati = null;
		vm.formModalUsoSolo.atividade = [];

		vm.modelFormDadosUsoSolo.id_gpx_au = null;
		vm.formModalUsoSolo.area_util = [];

		vm.modelFormDadosUsoSolo.id_gpx_esp = null;
		vm.formModalUsoSolo.especifico = [];

		enviarFormModalUsoSolo()
	};

	vm.onChangeFormModalUsoSoloAtividade = function () {
		vm.modelFormDadosUsoSolo.id_gpx_au = null;
		vm.formModalUsoSolo.area_util = [];

		vm.modelFormDadosUsoSolo.id_gpx_esp = null;
		vm.formModalUsoSolo.especifico = [];

		enviarFormModalUsoSolo()
	};

	vm.onChangeFormModalUsoSoloAreaUtil = function () {
		vm.modelFormDadosUsoSolo.id_gpx_esp = null;
		vm.formModalUsoSolo.especifico = [];

		enviarFormModalUsoSolo()
	};

	function enviarFormModalUsoSolo() {
		PlanoDiretorService.buscarUsoSolo(vm.modelFormDadosUsoSolo).then(function (result) {
			formatarDadosParaFormularioModalUsoSolo(result.data);
		});
	}

	function formatarDadosParaFormularioModalUsoSolo(resultadoApi) {
		resultadoApi.forEach(function (obj) {
			if (obj.id_gpx_tip && obj.nm_tipologia) {
				vm.formModalUsoSolo.tipologia.push({id: obj.id_gpx_tip, name: obj.nm_tipologia});
			}
			if (obj.id_gpx_ati && obj.nm_atividades) {
				vm.formModalUsoSolo.atividade.push({id: obj.id_gpx_ati, name: obj.nm_atividades});
			}
			if (obj.id_gpx_au && obj.nm_area_util) {
				vm.formModalUsoSolo.area_util.push({id: obj.id_gpx_au, name: obj.nm_area_util});
			}
			if (obj.id_gpx_esp && obj.especifico) {
				vm.formModalUsoSolo.especifico.push({id: obj.id_gpx_esp, name: obj.especifico});
			}
		});
		_.mapObject(vm.formModalUsoSolo, function (val, key) {
			vm.formModalUsoSolo[key] = _.uniq(val, 'id');
		});
	}

	vm.abrirModalDadosUsoSolo = function () {
		inicializarFormModalUsoSolo();
		inicializarModelFormDadosUsoSolo();

		vm.modelFormDadosUsoSolo['coordenada'] = ol.proj.transform(vm.coordenada, 'EPSG:3857', 'EPSG:4326');

		vm.modelFormDadosUsoSolo['id_gpx_uso'] = parseInt(vm.informacaoVetor['usosolo_selecionado']['id_gpx_uso']);
		vm.modelFormDadosUsoSolo['id_gpx_cv'] = parseInt(vm.informacaoVetor['logradouro_selecionado']['id_gpx_cv']);
		vm.modelFormDadosUsoSolo['id_gpx_log'] = parseInt(vm.informacaoVetor['logradouro_selecionado']['id_gpx_log']);

		vm.modelFormDadosUsoSolo['id_gpx_lot'] = parseInt(vm.informacaoVetor['id_gpx_lot']);
		vm.modelFormDadosUsoSolo['id_gpx_cid'] = parseInt(vm.informacaoVetor['ufcidade']['id_gpx_cid']);
		vm.modelFormDadosUsoSolo['schema'] = vm.schema;

		vm.informacaoVetor['afastamento']['pavimentos'].forEach(function (obj) {
			vm.formModalUsoSolo.numero_pavimentos.push({id: obj.id_gpx_afas, name: obj.num_pavimentos});
		});

		PlanoDiretorService.buscarUsoSolo(vm.modelFormDadosUsoSolo).then(function (result) {
			formatarDadosParaFormularioModalUsoSolo(result.data);
			vm.modalDadosUsoSolo = ngDialog.open({
				template: 'modalDadosUsoSolo',
				className: 'ngdialog-theme-default',
				width: '500px',
				scope: $scope,
				showClose: false,
				closeByEscape: false,
				closeByDocument: false,
				preCloseCallback: function () {
					vm.modelFormDadosUsoSolo = {};
				}
			});
		});
	};

	vm.closeModalDadosUsoSolo = function () {
		delete vm.informacaoVetor['usosolo_selecionado'];
		vm.modalDadosUsoSolo.close();
	};

	vm.submitModalDadosUsoSolo = function () {
		if (!vm.formularioModalUsoSolo.$valid) {
			toastr.error('Formulário inválido');
		} else {
			vm.informacaoVetor['usosolo_selecionado']['form'] = angular.copy(vm.modelFormDadosUsoSolo);
			vm.modalDadosUsoSolo.close();
		}
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Modal práticas sustentáveis

	vm.totalPraticasSustentaveisEscolhidas = 0;

	vm.calculeCoeficienteAplicado = function () {
		var numero = parseFloat(vm.informacaoVetor['zonas']['ca_basico']);
		var maximo = parseFloat(vm.informacaoVetor['zonas']['ca_maximo']);

		if (vm.totalPraticasSustentaveisEscolhidas > 0) {
			numero += vm.totalPraticasSustentaveisEscolhidas;
		}

		return numero > maximo ? maximo : numero;
	};

	vm.abrirModalPraticasSustentaveis = function () {
		ngDialog.open({
			template: 'modalPraticasSustentaveis',
			className: 'ngdialog-theme-default',
			width: '500px',
			scope: $scope,
			showClose: true,
			closeByEscape: false,
			closeByDocument: true,
			preCloseCallback: function () {
				return true
			}
		});
	};

	vm.onChangePraticasSustentaveisInput = function (obj) {
		_.mapObject(vm.informacaoVetor['praticas_sustentaveis_escolhidas'], function (val, key) {
			if (key === obj.id_gpx_ps) {
				if (vm.informacaoVetor['praticas_sustentaveis_escolhidas'][key]) {
					vm.totalPraticasSustentaveisEscolhidas += parseFloat(obj.caps);
				} else {
					vm.totalPraticasSustentaveisEscolhidas -= parseFloat(obj.caps);
				}
			}
		});
		vm.totalPraticasSustentaveisEscolhidas = Math.round(vm.totalPraticasSustentaveisEscolhidas * 100) / 100;
		console.log(vm.totalPraticasSustentaveisEscolhidas);

		if (vm.totalPraticasSustentaveisEscolhidas > parseFloat(vm.informacaoVetor['zonas']['ca_praticas'])) {
			vm.totalPraticasSustentaveisEscolhidas = parseFloat(vm.informacaoVetor['zonas']['ca_praticas']);
		}
		console.log(vm.totalPraticasSustentaveisEscolhidas);
	};

	// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Tratativas para PDF

	vm.inicializarFuncoesPDF = function () {
		var docDefinition = PlanoDiretorRelatorioService.getRelatorio(vm);

		vm.baixarPdf = function () {
			$window.open(pdfMake.createPdf(docDefinition).download(), '_blank');
		};

		vm.imprimirPdf = function () {
			var newWindow = window.open();
			newWindow.document.body.innerHTML = '' +
				'<iframe id="printPdf" name="printPdf" style="width: 100%; height: 100%"></iframe>';

			var pdfDocGenerator = pdfMake.createPdf(docDefinition);
			pdfDocGenerator.getDataUrl(function (dataUrl) {
				var iframe = newWindow.document.querySelector('#printPdf');
				iframe.src = dataUrl;
			});
		};
	};

}
